import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { IpFilterIds, IpFilters, SessionsSettings } from './models';

@Injectable({
  providedIn: 'root',
})
export class SessionsService {
  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private alcmeonContext: AlcmeonContextService
  ) {}

  updateCompanySettings(data: SessionsSettings): Observable<SessionsSettings> {
    return this.http.post<SessionsSettings>(
      `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/sessions-settings`,
      data
    );
  }

  getCompanySettings(): Observable<SessionsSettings> {
    return this.http
      .get<SessionsSettings>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/sessions-settings`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  getIpFilters(): Observable<IpFilters> {
    return this.http
      .get<IpFilters>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/ip-filters`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  addIpFilter(data: IpFilters): Observable<IpFilters> {
    return this.http
      .post<IpFilters>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/ip-filters`, data)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteIpFilter(ipFilterId: number): Observable<IpFilters> {
    return this.http
      .delete<IpFilters>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/ip-filters/${ipFilterId}`)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  deleteIpFilters(ipFilterIds: IpFilterIds): Observable<IpFilters> {
    return this.http
      .delete<IpFilters>(`${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/ip-filters/`, { body: ipFilterIds })
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
